





import AbstractColumnLink from '@/abstract/ColumnLink'
import AbstractColumnValue from '@/abstract/ColumnValue'
import mixins from 'vue-typed-mixins'

export default mixins(AbstractColumnLink, AbstractColumnValue).extend({
  computed: {
    classes(): string | undefined {
      return this.init?.classes
    },
  },
})
